// extracted by mini-css-extract-plugin
module.exports = {"root":"about-clients-module--root--dw2rH","list":"about-clients-module--list--1DZNM","listItem":"about-clients-module--list-item--1Wxxn"};